import { SelectNew } from "antd";
import WeaRangePicker from "../wea-range-picker";
import cloneDeep from "lodash/cloneDeep";
import isEmpty from "lodash/isEmpty";
const Option = SelectNew.Option;

class WeaDateGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rangeValue: []
    };
    if (!isEmpty(props.values) && !isEmpty(props.domkey)) {
      if (props.values[props.domkey[1]] && props.values[props.domkey[2]]) {
        this.setState({
          rangeValue: [
            new Date(props.values[props.domkey[1]]),
            new Date(props.values[props.domkey[2]])
          ]
        });
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    const { value, form, domkey } = nextProps;
    if (this.props.value == "6" && value !== "6" && form) {
      let clear = {};
      clear[domkey[1]] = "";
      clear[domkey[2]] = "";
      form.setFieldsValue(clear);
      this.setState({ rangeValue: [] });
    }
  }
  isDisabledDate = (yearOne, monthOne, dayOne, yearTwo, monthTwo, dayTwo) => {
    let bool = false;
    if (yearTwo > yearOne) bool = true;
    else if (yearTwo === yearOne) {
      if (monthTwo > monthOne) bool = true;
      else if (monthTwo === monthOne) {
        if (dayTwo > dayOne) bool = true;
      }
    }
    return bool;
  };
  getDisabledDate = (current, value, isStartValue = false) => {
    let bool = false;
    if (current && value) {
      const currentYear = current.getYear();
      const currentMonth = current.getMonth() + 1;
      const currentDay = current.getDayOfMonth();
      const year = new Date(value).getFullYear();
      const month = new Date(value).getMonth() + 1;
      const day = new Date(value).getDate();
      if (isStartValue) {
        bool = this.isDisabledDate(
          currentYear,
          currentMonth,
          currentDay,
          year,
          month,
          day
        );
      } else {
        bool = this.isDisabledDate(
          year,
          month,
          day,
          currentYear,
          currentMonth,
          currentDay
        );
      }
    }
    return bool;
  };
  render() {
    let theProps = cloneDeep(this.props);
    const {
      datas,
      value,
      form,
      domkey,
      rangeValue,
      viewAttr,
      textDecoration,
      className = "",
      isInline,
      style
    } = this.props;
    let disabled = false;
    if (viewAttr == "1") disabled = true;
    return (
      <div
        className={`wea-date-group ${className} ${isInline ? "isInline" : ""}`}
        style={style}
      >
        <SelectNew
          defaultValue="0"
          {...theProps}
          disabled={disabled}
          size={"default"}
          className={`wea-date-group-select ${textDecoration &&
            "text-decoration"}`}
        >
          {datas &&
            datas.map(d => {
              return <Option value={d.value}>{d.name}</Option>;
            })}
        </SelectNew>
        {value === "6" && ( // 指定日期范围更换为WeaRangePicker组件
          <div className="wea-date-group-rangePicker">
            <WeaRangePicker
              value={
                rangeValue || [
                  form && form.getFieldValue(domkey[1]),
                  form && form.getFieldValue(domkey[2])
                ]
              }
              viewAttr={viewAttr}
              textDecoration={textDecoration}
              onChange={v => {
                form &&
                  form.setFieldsValue({
                    [domkey[1]]: v[0],
                    [domkey[2]]: v[1]
                  });
                this.setState({ rangeValue: v });
              }}
            />
          </div>
        )}
        {/* {value === "6" && (
          <DatePicker
            disabled={disabled}
            textDecoration={textDecoration}
            style={{ width: "32%", marginLeft: "2%", minWidth: 100 }}
            value={startValue || (form && form.getFieldValue(domkey[1]))}
            disabledDate={current =>
              this.getDisabledDate(current, this.state.endValue)
            }
            // disabledDate={current =>{return this.state.endValue && current && current.getTime() > this.state.endValue.getTime()}}
            format="yyyy-MM-dd"
            onChange={(a, b) => {
              let clear = {};
              clear[domkey[1]] = b;
              form && form.setFieldsValue(clear);
              this.setState({ startValue: a });
            }}
          />
        )}
        {value === "6" && (
          <DatePicker
            disabled={disabled}
            textDecoration={textDecoration}
            style={{ width: "32%", marginLeft: "2%", minWidth: 100 }}
            value={endValue || (form && form.getFieldValue(domkey[2]))}
            disabledDate={current =>
              this.getDisabledDate(current, this.state.startValue, true)
            }
            // disabledDate={current =>{return this.state.startValue && current && current.getTime() < this.state.startValue.getTime()}}
            format="yyyy-MM-dd"
            onChange={(a, b) => {
              let clear = {};
              clear[domkey[2]] = b;
              form && form.setFieldsValue(clear);
              this.setState({ endValue: a });
            }}
          />
        )} */}
      </div>
    );
  }
}

export default WeaDateGroup;



// WEBPACK FOOTER //
// ./ecology9/wea-date-group/index-old.js